import { c as _c } from "react/compiler-runtime";
import type { ListRecommendPolicyDto } from '__generated__/api/auth';
import { cn } from '@core/utils';
import Link from 'next/link';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { getDdayColorClass, getDdayText, parseDday } from '../_lib/utils';
import { BookmarkButton } from './BookmarkButton';
interface TimelineCardProps {
  policy: ListRecommendPolicyDto;
}
export const TimelineCard = t0 => {
  const $ = _c(62);
  const {
    policy
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== policy.agency || $[1] !== policy.agencyLogo || $[2] !== policy.aiSummary || $[3] !== policy.daysAgo || $[4] !== policy.dday || $[5] !== policy.dueDateEnd || $[6] !== policy.id || $[7] !== policy.metaPolicyIdIdx || $[8] !== policy.newPolicy || $[9] !== policy.policyName || $[10] !== policy.wishlistCount || $[11] !== policy.wishlistYN) {
    const parsedDday = parseDday(policy.dday);
    T0 = Link;
    if ($[20] !== policy.metaPolicyIdIdx) {
      t6 = ROUTES.POLICY_DETAIL.withSearchParams({
        dynamicPath: {
          idIdx: policy.metaPolicyIdIdx
        }
      });
      $[20] = policy.metaPolicyIdIdx;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t7 = "block p-24 pb-0";
    t4 = "flex flex-col gap-12 border-b border-Gray-300 bg-Gray-white transition-all ease-out active:scale-[0.995]";
    let t8;
    if ($[22] !== policy.agency || $[23] !== policy.agencyLogo) {
      t8 = <Image src={policy.agencyLogo} alt={policy.agency} width={20} height={20} className="size-20 rounded-pill border-1 border-Gray-300" />;
      $[22] = policy.agency;
      $[23] = policy.agencyLogo;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] !== policy.agency) {
      t9 = <span className="font-600 text-Gray-500 typo-caption1">{policy.agency}</span>;
      $[25] = policy.agency;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] !== t8 || $[28] !== t9) {
      t10 = <div className="flex items-center gap-4">{t8}{t9}</div>;
      $[27] = t8;
      $[28] = t9;
      $[29] = t10;
    } else {
      t10 = $[29];
    }
    let t11;
    if ($[30] !== policy.newPolicy) {
      t11 = policy.newPolicy && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2 ml-4 inline-block shrink-0 align-middle"><rect width="16" height="16" rx="8" className="fill-O-500" /><path d="M10.95 4.43V11.5H9.68L6.57 7.01H6.52V11.5H5.05V4.43H6.34L9.43 8.92H9.49V4.43H10.95Z" className="fill-Gray-white" /></svg>;
      $[30] = policy.newPolicy;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    let t12;
    if ($[32] !== policy.policyName || $[33] !== t11) {
      t12 = <h3 className="line-clamp-2 max-w-[90%] break-words font-600 text-Gray-black transition-colors typo-body3 group-hover:text-Gray-600">{policy.policyName}{t11}</h3>;
      $[32] = policy.policyName;
      $[33] = t11;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t13;
    if ($[35] !== t10 || $[36] !== t12) {
      t13 = <div className="group flex min-w-0 flex-1 flex-col gap-6">{t10}{t12}</div>;
      $[35] = t10;
      $[36] = t12;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    let t14;
    if ($[38] !== policy.agency || $[39] !== policy.id || $[40] !== policy.policyName || $[41] !== policy.wishlistCount || $[42] !== policy.wishlistYN) {
      t14 = <div className="shrink-0"><BookmarkButton policyId={policy.id} policyName={policy.policyName} agency={policy.agency} isBookmarked={policy.wishlistYN} bookmarkCount={policy.wishlistCount} /></div>;
      $[38] = policy.agency;
      $[39] = policy.id;
      $[40] = policy.policyName;
      $[41] = policy.wishlistCount;
      $[42] = policy.wishlistYN;
      $[43] = t14;
    } else {
      t14 = $[43];
    }
    if ($[44] !== t13 || $[45] !== t14) {
      t5 = <div className="flex items-start justify-between gap-24">{t13}{t14}</div>;
      $[44] = t13;
      $[45] = t14;
      $[46] = t5;
    } else {
      t5 = $[46];
    }
    t1 = "flex flex-col gap-12 pb-24";
    if ($[47] !== policy.aiSummary) {
      t2 = policy.aiSummary && <div className="rounded-small bg-Gray-25 px-14 py-12"><p className="line-clamp-2 font-400 text-Gray-600 typo-caption1"><span className="mb-2 mr-2 inline-flex items-center gap-2 whitespace-nowrap align-middle"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0"><defs><linearGradient id="ai-gradient-timeline" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="rotate(125.96)"><stop offset="0%" stopColor="#33A6FF" /><stop offset="100%" stopColor="#6A00FF" /></linearGradient></defs><path d="M7.89 5.29C7.67 5.2 7.5 5.02 7.41 4.81L6.7 3.19C6.56 2.94 6.18 2.94 6.05 3.19L5.34 4.81C5.24 5.02 5.07 5.19 4.86 5.29L3.95 5.68C3.68 5.81 3.68 6.18 3.95 6.31L4.86 6.7C5.08 6.79 5.25 6.97 5.34 7.18L6.05 8.81C6.19 9.06 6.57 9.06 6.7 8.81L7.41 7.18C7.51 6.97 7.68 6.8 7.89 6.7L8.8 6.31C9.07 6.18 9.07 5.81 8.8 5.68L7.89 5.29Z" fill="url(#ai-gradient-timeline)" /><path d="M19.18 10.166C18.53 9.88 18.01 9.34 17.74 8.68L15.59 3.61C15.2 2.8 14.05 2.8 13.66 3.61L11.51 8.68C11.23 9.34 10.71 9.88 10.07 10.166L7.35 11.4C6.55 11.79 6.55 12.96 7.35 13.35L10.07 14.584C10.72 14.87 11.24 15.41 11.51 16.07L13.66 21.14C14.05 21.95 15.2 21.95 15.59 21.14L17.74 16.07C18.02 15.41 18.54 14.87 19.18 14.584L21.9 13.35C22.701 12.96 22.701 11.79 21.9 11.4L19.18 10.166Z" fill="url(#ai-gradient-timeline)" /><path d="M6.21 15.25C6.33 15.54 6.55 15.77 6.83 15.9L7.99 16.45C8.34 16.62 8.34 17.13 7.99 17.3L6.83 17.85C6.55 17.98 6.33 18.22 6.21 18.5L5.29 20.74C5.12 21.09 4.63 21.09 4.46 20.74L3.54 18.5C3.42 18.21 3.2 17.98 2.92 17.85L1.76 17.3C1.41 17.13 1.41 16.62 1.76 16.45L2.92 15.9C3.2 15.77 3.42 15.53 3.54 15.25L4.46 13.01C4.63 12.66 5.12 12.66 5.29 13.01L6.21 15.25Z" fill="url(#ai-gradient-timeline)" /></svg><span className="bg-clip-text font-700 text-transparent typo-caption1" style={{
              background: "linear-gradient(125.96deg, #33A6FF -8.28%, #6A00FF 101.68%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}>AI 요약</span></span>{" "}{policy.aiSummary}</p></div>;
      $[47] = policy.aiSummary;
      $[48] = t2;
    } else {
      t2 = $[48];
    }
    t3 = parsedDday !== undefined && <div className="flex items-center gap-8"><span className={cn("font-600 typo-caption1", getDdayColorClass(parsedDday))}>{parsedDday === -1 && policy.dueDateEnd ? `${policy.dueDateEnd} 마감` : getDdayText(parsedDday)}</span>{policy.daysAgo && parsedDday !== -1 && <span className="ml-auto font-600 text-Gray-500 typo-caption1">{policy.daysAgo}</span>}</div>;
    $[0] = policy.agency;
    $[1] = policy.agencyLogo;
    $[2] = policy.aiSummary;
    $[3] = policy.daysAgo;
    $[4] = policy.dday;
    $[5] = policy.dueDateEnd;
    $[6] = policy.id;
    $[7] = policy.metaPolicyIdIdx;
    $[8] = policy.newPolicy;
    $[9] = policy.policyName;
    $[10] = policy.wishlistCount;
    $[11] = policy.wishlistYN;
    $[12] = T0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    T0 = $[12];
    t1 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
  }
  let t8;
  if ($[49] !== t1 || $[50] !== t2 || $[51] !== t3) {
    t8 = <div className={t1}>{t2}{t3}</div>;
    $[49] = t1;
    $[50] = t2;
    $[51] = t3;
    $[52] = t8;
  } else {
    t8 = $[52];
  }
  let t9;
  if ($[53] !== t4 || $[54] !== t5 || $[55] !== t8) {
    t9 = <article className={t4}>{t5}{t8}</article>;
    $[53] = t4;
    $[54] = t5;
    $[55] = t8;
    $[56] = t9;
  } else {
    t9 = $[56];
  }
  let t10;
  if ($[57] !== T0 || $[58] !== t6 || $[59] !== t7 || $[60] !== t9) {
    t10 = <T0 href={t6} className={t7}>{t9}</T0>;
    $[57] = T0;
    $[58] = t6;
    $[59] = t7;
    $[60] = t9;
    $[61] = t10;
  } else {
    t10 = $[61];
  }
  return t10;
};